window.phoneField = () => {
    const phoneField = document.querySelectorAll('.wpforms-field-phone');

    if (typeof phoneField === 'undefined' || !phoneField.length) return;

    function updatePhoneField(field, value = 'GB') {
        const flagContainer = field.querySelector('.iti__selected-flag');

        flagContainer.querySelector('.iti__flag').textContent = value;
    }

    phoneField.forEach((field) => {
        const flagInput = field.querySelector('.iti__flag-container');

        if (typeof flagInput === 'undefined' || !flagInput) return;

        let currentSelection = 'GB';

        updatePhoneField(field, currentSelection);

        const inputOptions = flagInput.querySelectorAll('.iti__country-list>li');

        inputOptions.forEach((option) => {
            option.addEventListener('click', () => {
                currentSelection = option.getAttribute('data-country-code').toUpperCase();
                updatePhoneField(field, currentSelection);
            });
        });
    });
}

// set up functionality for the join button on each club page
// if there is a join modal page, then we need to redirect to that page, otherwise we need to redirect to the JOL page
window.setUpJoinButton = () => {
    const joinButton = document.querySelector('a[href*="join-club-online"]');
    const clubIdRow = document.cookie.split('; ').find(row => row.startsWith('clubId='));
    const clubId = clubIdRow ? clubIdRow.split('=')[1] : null;

    const joinModalPageRow = document.cookie.split('; ').find(row => row.startsWith('joinModalPage='));
    const joinModalPage = joinModalPageRow ? joinModalPageRow.split('=')[1] : null;

    console.log('>> joinModalPage', joinModalPage);
    
    if (joinButton) {
        joinButton.addEventListener('click', (e) => {
            console.log('joinButton clicked');
            e.preventDefault();
            
            if(!joinModalPage) {
                console.log('No join modal page, redirecting to JOL');
                if(clubId) {
                    window.location.href = `/jol/?clubId=${clubId}`;
                } else {
                    console.log('No club ID, redirecting to JOL');
                    window.location.href = '/jol/';
                }
                return;
            }

            if(!clubId) {
                console.log('No club ID, redirecting to JOL');
                window.location.href = '/jol/';
                return;
            }

            if (window.modal && window.modal.openModal) {
                console.log(`/${joinModalPage}/?modal=yes&clubId=${clubId}`);
                window.modal.openModal(`/${joinModalPage}/?modal=yes&clubId=${clubId}`, 'join-online-modal');
            } else {
                console.error('Modal system not ready');
            }
        });
    }
}

window.smoothScrollFoodMenu = () => {
    const sidebar = document.querySelector('.food-menu-sidebar');
    if (!sidebar) return;

    const links = sidebar.querySelectorAll('a[href*="#"]');
    
    links.forEach((link) => {
        link.addEventListener('click', (e) => {
            const href = link.getAttribute('href');
            const hashMatch = href.match(/#(.+)$/);
            
            if (hashMatch) {
                e.preventDefault();
                const targetId = hashMatch[1];
                const targetElement = document.getElementById(targetId);
                
                if (targetElement && window.pegasus && window.pegasus.scroll) {
                    window.pegasus.scroll(targetElement, -10); 
                } else {
                    console.warn(`Target element with ID "${targetId}" not found`);
                }
            }
        });
    });
}

window.onload = () => {
    window.phoneField();
    window.setUpJoinButton();
    window.smoothScrollFoodMenu();
}